// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2SkxF","footer":"Form_footer__3M8XF"};